// extracted by mini-css-extract-plugin
export var thumbnail = "AutoPauseVideo-module--thumbnail--d30eb";